import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { BookOpen, Award, Leaf } from 'lucide-react';
export function AuthorSection() {
  return <Section className="bg-white" data-id="element-22">
      <div className="max-w-2xl mx-auto" data-id="element-23">
        {/* Author Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5" data-id="element-24">
          <p className="text-sm uppercase tracking-widest text-[#2D5016] font-bold mb-4" data-id="element-25">
            Conoce a la autora
          </p>

          {/* Author Image */}
          <div className="relative inline-block mb-4" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/fVDFWEgb9yBsoFRrBPG9qe/autora.png" alt="Dra. Elena Ramírez - Autora de Tu Botiquín Natural 30+" className="w-40 h-40 md:w-48 md:h-48 rounded-full object-cover object-top border-4 border-[#2D5016]/20 shadow-xl mx-auto" data-id="element-27" />
            <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-[#2D5016] text-white text-xs font-bold px-3 py-1 rounded-full shadow-md whitespace-nowrap" data-id="element-28">
              ✍️ Autora Verificada
            </div>
          </div>

          {/* Author Name & Title */}
          <h3 className="text-2xl md:text-3xl font-bold text-[#2C1810] mb-1" data-id="element-29">
            Dra. Elena Ramírez
          </h3>
          <p className="text-[#2D5016] font-medium text-base mb-4" data-id="element-30">
            Naturópata · Herbalista Certificada · Investigadora en Medicina
            Tradicional
          </p>
        </motion.div>

        {/* Credentials */}
        <div className="grid grid-cols-3 gap-3 mb-5" data-id="element-31">
          {[{
          icon: BookOpen,
          label: '15+ años',
          sub: 'de investigación'
        }, {
          icon: Award,
          label: '2,800+',
          sub: 'familias ayudadas'
        }, {
          icon: Leaf,
          label: '40+',
          sub: 'recetas dosificadas'
        }].map((cred, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2 + i * 0.1
        }} className="text-center bg-[#FDF8F0] rounded-lg p-3 border border-[#2D5016]/10" data-id="element-32">
              <cred.icon className="w-5 h-5 text-[#2D5016] mx-auto mb-1" data-id="element-33" />
              <p className="font-bold text-[#2C1810] text-sm" data-id="element-34">{cred.label}</p>
              <p className="text-xs text-gray-500" data-id="element-35">{cred.sub}</p>
            </motion.div>)}
        </div>

        {/* Author Story */}
        <div className="bg-[#FDF8F0] rounded-xl p-4 border border-[#2D5016]/10 text-[#2C1810] text-sm md:text-base leading-relaxed space-y-3" data-id="element-36">
          <p data-id="element-37">
            <span className="font-bold text-[#2D5016]" data-id="element-38">
              "Todo empezó con mi mamá."
            </span>{' '}
            A los 48 años, sus rodillas no la dejaban caminar al mercado. El
            colesterol en 255. Insomnio desde las 3am. Los doctores le daban
            pastillas que le destruían el estómago.
          </p>
          <p data-id="element-39">
            Fue entonces cuando volví a los cuadernos de mi abuela. Recetas
            escritas a mano, con dosis exactas, rotaciones semanales y
            combinaciones que ningún médico moderno enseña.
          </p>
          <p data-id="element-40">
            Pasé{' '}
            <span className="font-bold" data-id="element-41">
              15 años investigando, probando y dosificando
            </span>{' '}
            cada receta según peso corporal. El resultado: un sistema completo
            que mi familia usa cada día — y que ahora comparto contigo.
          </p>
          <p className="font-bold text-[#2D5016] text-center text-lg pt-1" data-id="element-42">
            Este botiquín es mi legado. Y ahora es tuyo.
          </p>
        </div>
      </div>
    </Section>;
}